import { motion } from "motion/react";
import { Linkedin } from "lucide-react";
import { Link } from "react-router";
import { useCookieConsent } from "../shared/cookie-consent/CookieConsentContext";

const IVIZ_APP_URL = "https://iviz.coharts.com/login";
const COHARTS_LOGO = "/brand/coharts/coharts-logo-full.png";

export function Footer() {
  const { openPreferences } = useCookieConsent();
  return (
    <motion.footer initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} className="bg-[#FAFAFA] dark:bg-black border-t border-[#0A0A0F]/8 dark:border-white/8">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid md:grid-cols-4 gap-10">
        <div className="space-y-4 md:col-span-1">
          <img src={COHARTS_LOGO} alt="Coharts" className="h-11 w-auto" />
          <p className="text-sm text-[#5C5C66] dark:text-[#9A9A9A] leading-relaxed">
            Intelligence for complex decisions.
          </p>
          <a href="https://www.linkedin.com/company/coharts" target="_blank" rel="noopener noreferrer" className="inline-flex text-[#5C5C66] dark:text-[#9A9A9A] hover:text-[#1E4FD8] dark:hover:text-[#8CC0F0] transition-colors">
            <Linkedin size={16} />
          </a>
        </div>

        <div>
          <p className="text-[10px] uppercase tracking-widest font-semibold text-[#5C5C66] dark:text-[#9A9A9A] mb-4">Products</p>
          <ul className="space-y-2.5">
            <li><a href={IVIZ_APP_URL} target="_blank" rel="noopener noreferrer" className="text-sm text-[#5C5C66] dark:text-[#9A9A9A] hover:text-[#0A0A0F] dark:hover:text-white transition-colors">iViz</a></li>
            <li><Link to="/foresight" className="text-sm text-[#5C5C66] dark:text-[#9A9A9A] hover:text-[#0A0A0F] dark:hover:text-white transition-colors">Foresight</Link></li>
            <li><Link to="/pricing" className="text-sm text-[#5C5C66] dark:text-[#9A9A9A] hover:text-[#0A0A0F] dark:hover:text-white transition-colors">Pricing</Link></li>
          </ul>
        </div>

        <div>
          <p className="text-[10px] uppercase tracking-widest font-semibold text-[#5C5C66] dark:text-[#9A9A9A] mb-4">Platform</p>
          <ul className="space-y-2.5">
            <li><Link to="/evidence" className="text-sm text-[#5C5C66] dark:text-[#9A9A9A] hover:text-[#0A0A0F] dark:hover:text-white transition-colors">Evidence</Link></li>
          </ul>
        </div>

        <div>
          <p className="text-[10px] uppercase tracking-widest font-semibold text-[#5C5C66] dark:text-[#9A9A9A] mb-4">Company</p>
          <ul className="space-y-2.5">
            <li><Link to="/contact/iviz" className="text-sm text-[#5C5C66] dark:text-[#9A9A9A] hover:text-[#0A0A0F] dark:hover:text-white transition-colors">Contact iViz</Link></li>
            <li><Link to="/contact/foresight" className="text-sm text-[#5C5C66] dark:text-[#9A9A9A] hover:text-[#0A0A0F] dark:hover:text-white transition-colors">Contact Foresight</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#0A0A0F]/8 dark:border-white/8">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-5 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-[11px] text-[#5C5C66] dark:text-[#7A7A80]">© 2026 Coharts Inc. All rights reserved. · Intelligence for Complex Decisions. · FDA-aligned methodology</p>
          <ul className="flex flex-wrap justify-center gap-x-5 gap-y-1.5">
            <li><Link to="/cookie-policy" className="text-[11px] text-[#5C5C66] dark:text-[#7A7A80] hover:text-[#0A0A0F] dark:hover:text-white transition-colors">Cookie Policy</Link></li>
            <li><Link to="/privacy-policy" className="text-[11px] text-[#5C5C66] dark:text-[#7A7A80] hover:text-[#0A0A0F] dark:hover:text-white transition-colors">Privacy Policy</Link></li>
            <li><Link to="/terms-and-conditions" className="text-[11px] text-[#5C5C66] dark:text-[#7A7A80] hover:text-[#0A0A0F] dark:hover:text-white transition-colors">Terms &amp; Conditions</Link></li>
            <li><Link to="/cancellation-policy" className="text-[11px] text-[#5C5C66] dark:text-[#7A7A80] hover:text-[#0A0A0F] dark:hover:text-white transition-colors">Cancellation &amp; Refund Policy</Link></li>
            <li><button onClick={openPreferences} className="text-[11px] text-[#5C5C66] dark:text-[#7A7A80] hover:text-[#0A0A0F] dark:hover:text-white transition-colors">Cookie settings</button></li>
          </ul>
        </div>
      </div>
    </motion.footer>
  );
}
